import { LitEventManger } from "../utils/event.js";
export function eventManager() {
    return function (target, name) {
        const descriptor = {
            get() {
                if (!this._eventManager) {
                    this._eventManager = new LitEventManger();
                }
                return this._eventManager;
            },
            enumerable: true,
            configurable: true,
        };
        Object.defineProperty(target, name, descriptor);
    };
}
//# sourceMappingURL=event.js.map